import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "vuex";
  import { onMounted, ref } from "vue";
  import { UserInterface } from "@/types/UserInterface";
  import { getFirstLastName } from "@/helpers/user";
  import getUserRole from "@/helpers/getUserRole";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandownerInfo',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const user = ref<UserInterface | null>(null);
  const { isSalesPersonRole, isLandownerRole } = getUserRole();

  onMounted(() => {
    store.dispatch("user/getUser", store.state.user.data._id).then((res) => {
      user.value = res.data;
    });
  });

const __returned__ = { store, user, isSalesPersonRole, isLandownerRole, get useStore() { return useStore }, onMounted, ref, get UserInterface() { return UserInterface }, get getFirstLastName() { return getFirstLastName }, get getUserRole() { return getUserRole } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})